import { jsx as _jsx } from "react/jsx-runtime";
import Script from "next/script";
import React from "react";
export var googleTagManagerId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID || "";
var GoogleTagManager = function(param) {
    var googleTagManagerId = param.googleTagManagerId;
    switch(process.env.NEXT_PUBLIC_ENV){
        case "production":
            return /*#__PURE__*/ _jsx(Script, {
                id: "gtm",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=YqEoMaYm8rYNXVfdazKsrg&gtm_preview=env-1&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(googleTagManagerId, "');\n          ")
                }
            });
        case "staging":
            return /*#__PURE__*/ _jsx(Script, {
                id: "gtm",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=EXmrIPeYaGpClesj0JUQ6g&gtm_preview=env-15&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(googleTagManagerId, "');\n          ")
                }
            });
        case "development":
            return /*#__PURE__*/ _jsx(Script, {
                id: "gtm",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=zQNk2648OdG8lE7g6HnMYw&gtm_preview=env-4&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(googleTagManagerId, "');\n          ")
                }
            });
        default:
            return /*#__PURE__*/ _jsx(Script, {
                id: "gtm",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=P1BUdLOFleCGpESq98mpmw&gtm_preview=env-11&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(googleTagManagerId, "');\n          ")
                }
            });
    }
};
export default GoogleTagManager;
